import "./styles.css";
import "./base.css";

import Header from "./Header";
import Home from "./Home/Home";
import { Footer } from "./SubFooter";

/* Router */
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Send from "./Send";

export default function App() {


  return (
    <div className="App">
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <ScrollToTop />
        <Header />
        {/* Routes */}
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/send" element={<Send />} />
          {/* Page Not Found */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        {/* End Routes */}
        <Footer />
      </BrowserRouter>
    </div>
  );
}
